"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacing = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../components");
var Customize_1 = require("./Customize");
var Margin_1 = require("./Margin");
var Padding_1 = require("./Padding");
var Spacing = function () { return (react_1.default.createElement(components_1.Doc, { title: "Spacing" },
    react_1.default.createElement(Margin_1.Margin, null),
    react_1.default.createElement(Padding_1.Padding, null),
    react_1.default.createElement(Customize_1.SpaceCustomize, null))); };
exports.Spacing = Spacing;
